import React from 'react';
import HowTo from '../../components/content/investors/how.to';
import InvestAt from '../../components/content/investors/invest.at';
import CurrentlyOpen from '../../components/content/investors/open';
import UnservedSME from '../../components/content/investors/unserved.sme';
import Combining from '../../components/content/investors/combining';
import Ranges from '../../components/content/investors/range';
import Profitable from '../../components/content/investors/profitable';
import Achievements from '../../components/content/investors/achievements';
import Featured from '../../components/content/investors/featured';

const Investors = () => (
  <>
    <InvestAt />
    <UnservedSME />
    <Ranges />
    <Combining />
    <Achievements />
    <Featured />
    <Profitable />
    <HowTo />
    <CurrentlyOpen />
  </>
);

export default Investors;
